<template>
  <div>
    <v-container>
      <v-layout wrap>
        <v-flex xs12 class="text-xs-left pb-4">
          <v-btn v-on:click.native="back">&larr; retour</v-btn>
        </v-flex>
        <v-flex xs12 v-if="isAdmin">
          <h2 class="text-xs-left headline">Administration</h2>
          <v-card>
            <v-list two-line>
              <v-subheader>Actions</v-subheader>
              <v-divider></v-divider>
              <v-list-tile v-on:click.native="reset">
                <v-list-tile-content>
                  <v-list-tile-title>Réinitialiser la tablette</v-list-tile-title>
                  <v-list-tile-sub-title>Cela effacera toutes les données</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon ripple>
                    <v-icon class="grey--text text--lighten-1">replay</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider></v-divider>
            </v-list>
          </v-card>
        </v-flex>
        <v-flex xs12 v-else>
          <v-text-field name="password" label="Merci de renseigner le mot de passe administrateur" v-model="password"></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

export default {
  name: `admin`,
  data () {
    return {
      password: ``,
    };
  },
  methods: {
    reset () {
      this.$store.dispatch(`resetTablet`)
      .then(() => {
        this.$router.push({ name: `Home` });
      });
    },
    back () {
      this.$router.push({ name: `Home` });
    },
  },
  computed: {
    isAdmin () {
      return this.$store.state.weviewObject ? this.password === this.$store.state.weviewObject.adminCode : false;
    },
  },
};

</script>



// WEBPACK FOOTER //
// Admin.vue?7f851dfa